/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import {combineReducers} from 'redux';

import * as t from './actions';


/**
 * Helper function to add an entity to the set of cached entities.
 */
const setEntity = (state, institution) => {
  return {
    ...state,
    ...{
      [institution.id]: institution
    }
  };
};

const institutionsById = (state = {}, action) => {
  switch (action.type) {

    case t.FETCH_INSTITUTION_SUCCESS: {
      return setEntity(state, action.payload.institution);
    }

    case t.FETCH_INSTITUTIONS_REQUEST_SUCCESS: {
      return action.institutions.reduce(setEntity, state);
    }

    case t.ADD_INSTITUTION: {
      return setEntity(state, action.institution);
    }

    default:
      return state;
  }
};

/**
 * Push an array of identifiers into another array, not allowing duplicates.
 *
 * @param state original state
 * @param newIds new identifiers to add
 * @return {*[]}
 */
const setIds = (state, newIds) => {
  return [...new Set([...state ,...newIds])];
};

const allInstitutions = (state = [], action) => {
  switch (action.type) {

    case t.FETCH_INSTITUTION_SUCCESS: {
      return setIds(state, [action.payload.institution.id]);
    }

    case t.FETCH_INSTITUTIONS_REQUEST_SUCCESS: {
      return setIds(state, action.institutions.map(institution => institution.id));
    }

    case t.ADD_INSTITUTION: {
      return setIds(state, [action.institution.id]);
    }

    default:
      return state;
  }
};

/**
 * This reducer manages the 'contextInstitution' strand of the application state.
 *
 * @param state the current context institution. Defaults to null if there isn't a context institution.
 * @param action the action received by the Redux store.
 * @returns {*} the new state of the 'contextInstitution'.
 */
const contextInstitutionReducer = (state = null, action) => {
  switch (action.type) {
    case t.CHANGE_CONTEXT_INSTITUTION_REQUEST_SUCCESS: {
      return action.institution == null ? null : action.institution.id;
    }

    case t.FETCH_INSTITUTIONS_REQUEST_SUCCESS: {
      if (!state && (action.institutions && action.institutions.length === 1)) {
        return action.institutions[0].id;
      }
      return state;
    }

    default:
      return state;
  }
};

/**
 * This reducer manages the user's authorized institutions.  These institutions are those directly associated
 * with the user in the WorldCat Registry or EIDM.
 */
const authorizedInstitutionsReducer = (state = [], action) => {
  switch (action.type) {
    case t.FETCH_INSTITUTIONS_REQUEST_SUCCESS: {
      return [...new Set([...state, ...action.institutions.map(institution => institution.id)])];
    }
    default:
      return state;
  }
};

/**
 * Reducer that manages the state under 'entities/institutions'.
 *
 * @param state the current state of the 'entities/institutions' branch.
 * @param action the action to perform.
 * @returns {*} the new contents of the 'entities/institutions' branch of the application state.
 */
const institutionsReducer = combineReducers({
  byId: institutionsById,
  allIds: allInstitutions,
  contextInstitution: contextInstitutionReducer,
  authorized: authorizedInstitutionsReducer

});

export default institutionsReducer;



// WEBPACK FOOTER //
// ./src/institutions/reducer.js